import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

export const styles = StyleSheet.create({
	container: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
		backgroundColor: THEME.colors.background.main,
		padding: `0 ${THEME.spacing.md}px`,
	},
	content: {
		textAlign: 'center',
		maxWidth: 500,
	},
	title: {
		fontSize: 28,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.md,
	},
	message: {
		fontSize: THEME.typography.fontSizes.md,
		color: THEME.colors.text.light,
		lineHeight: 1.5,
	},
});
